import { Component, OnInit, isDevMode, Input, ViewChildren, ViewChild } from '@angular/core';
import { Product, Format, FormatOption, BasketProduct } from 'src/app/_models';
import { CatalogService, UtilsService, ListsService } from 'src/app/_services';
import { BasketService } from 'src/app/_services/basket.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, Form, FormGroup } from '@angular/forms';
import { ConfirmModalComponent } from 'src/app/confirm-modal/confirm-modal.component';

declare const $ : any ;

@Component({
  selector: 'app-product-format-options-modal',
  templateUrl: './product-format-options-modal.component.html',
  styleUrls: ['./product-format-options-modal.component.css']
})
export class ProductFormatOptionsModalComponent implements OnInit {

  @Input() listId :  number;

  @ViewChild(ConfirmModalComponent) confirmAddModal: ConfirmModalComponent; 

  public commentsForm : FormGroup
  public product : Product;
  public bProduct : BasketProduct;

  public totalPrice : number;

  public selectedServiceFormat : Format;
  public selectedOption : FormatOption;

  public serviceFormats = new Map();

  constructor(
    private formBuilder: FormBuilder,
    public catalog : CatalogService,
    public translate : TranslateService,
    public utils : UtilsService,
    public basket : BasketService,
    public toastr : ToastrService,
    public listss : ListsService
  ) { }

  ngOnInit() {
    this.commentsForm = this.formBuilder.group({
      comments: [''],
    });

  }

  setProduct( product : Product){
    
    this.product = product
    this.serviceFormats = new Map<string,string>();

    this.commentsForm.controls.comments.setValue('');
    
    this.bProduct = new BasketProduct(null);
    this.bProduct.basket_position = 0;
    this.bProduct.product= this.product;
    this.bProduct.item_id = this.product.item_id;
    
    this.selectedServiceFormat = this.product.getServiceFormat();
    if (! this.selectedServiceFormat){
      if (isDevMode()){
        this.toastr.warning(`No s'ha trovat un format de servei. has_format : ${this.product.has_format} formats : ${this.product.formats.length}`);
      }
      this.selectedServiceFormat = null;
      this.selectedOption = null;
      return ;
    }

    this.product.formats.forEach(format => {
      this.serviceFormats.set(format.format_id, format.options[0].option_id);
    });
    this.setServiceFormat(this.selectedServiceFormat, this.selectedServiceFormat.options[0]);       

  }

  setServiceFormat(format : Format, option : FormatOption){
    this.selectedServiceFormat = format;
    this.selectedOption = option;
    this.bProduct.quantity = this.selectedOption.min;
    this.totalPrice = 0;
    this.serviceFormats.set(format.format_id, option.option_id);
    this.recalcPrice();
  }

  onFormatOptionChanged(format, option){
    this.serviceFormats.set(format.format_id, option.option_id);
    this.recalcPrice();
  }

  onServiceFormatOptionChanged(format : Format, option : FormatOption){    
    this.setServiceFormat(format, option);
  }

  less(){
    if (this.bProduct.quantity > this.selectedOption.min){
      this.bProduct.quantity -= this.selectedOption.interval;
    }
    else {
      this.bProduct.quantity = this.selectedOption.min;
    }
    this.recalcPrice();
  }

  more(){
    this.bProduct.quantity += this.selectedOption.interval;
    this.recalcPrice();
  }

  recalcPrice(){
    let option : FormatOption  = this.getPriceOption();
    this.totalPrice = this.bProduct.quantity * this.product.price  * option.percent;
  }

  getPriceOption() : FormatOption{
    let ret : FormatOption = null;

    this.serviceFormats.forEach( (v,k) =>{
      const option = this.product.getServiceFormatOption(k,v);
      if (option.percent > 0){
        ret = option;
      }
    });
    return ret;
  }

  add(){
    this.bProduct.notes = this.commentsForm.controls.comments.value;
    this.bProduct.selected_serviceFormatOption = this.selectedOption;
    this.bProduct.selected_format =  [...this.serviceFormats].reduce((o, [key, value]) => (o[key] = value, o), new Map());

    this.bProduct.selected_options = [];
    Object.keys (this.bProduct.selected_format).forEach (k => { 
        this.bProduct.selected_options.push( this.product.getServiceFormatOption(k, this.bProduct.selected_format[k]));
    });
   
    // Si se indica lista, añadir a la lista de usuario
    if (this.listId  && this.listId != 0){
      this.listss.addFormatLine(this.listId,0, this.bProduct).subscribe(result =>{
        $('#modal-format-options-product').modal('hide');
      });
    } else { // Añadir a la cesta

      // If basket contains product with same service options,  user must confirm to add
      let p : BasketProduct = this.basket.findProduct(this.bProduct);
      if (p){
        $('#modal-format-options-product').modal('hide');

        this.confirmAddModal.title = this.translate.instant('CATALOG.ASK_PRODUCTADD_TITLE');
        this.confirmAddModal.message = this.translate.instant('CATALOG.ASK_PRODUCTADD_MESSAGE', {
          name : p.product.getText(this.translate.currentLang) , 
          mainFormat :  p.getMainFormatText(this.translate.currentLang, this.translate.instant('UNITS')),
          optionFormat :  p.getOptionFormatText(this.translate.currentLang, this.translate.instant('BASKET.FORMAT')),
          quantity : p.quantity,
          more_quantity : this.bProduct.quantity
        });

        $(`#modal-confirm-${p.item_id}`).modal('show');
      }
      else {
        this.basket.add(this.bProduct).subscribe( result =>{
          $('#modal-format-options-product').modal('hide');
        });            
      }

      this.selectedServiceFormat = null;
      this.selectedOption = null;

    }
  }

  onConfirmAdd(){    
    let p : BasketProduct = this.basket.findProduct(this.bProduct);
    this.bProduct.quantity = p.quantity + this.bProduct.quantity;
    this.basket.add(this.bProduct).subscribe();  
  }

}
